/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2024, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/
import { EventEmitter, Injectable } from '@angular/core';
import { AeroDialogService } from '../../aero/aero-dialog/aero-dialog.service';
import { TranslationService } from '../../common/translation.service';
import { ImageCropperComponent } from './image-cropper.component';

/**
 * Handle the image crop dialog option.
 */
@Injectable({
  providedIn: 'root',
})
export class ImageCropperDialogService {

  constructor(
    private $translate : TranslationService,
    private aeroDialogService: AeroDialogService,
  ) { }

  /**
   * It opens crop dialog.
   * @param image image asset
   * @param rotate rotate degree
   * @param save save handler
   * @param type Cropper window design.
   * @param frameSize Max size of image frame for scaling.
   * @param imageSize Max size of image for scaling.
   */
  show(image, rotate, save, type, frameSize, imageSize, ckeData?) {
    const onSave: EventEmitter<any> = new EventEmitter<any>();
    onSave.subscribe((response) => {
      save(response);
    });
    const showCaptionOptions = {
      width: '34em',
      modal: true,
      dismissableMask: true,
      styleClass: 'aero-dialog orientation1',
      showHeader: false,
      data: {
        onSave,
        rotate,
        image,
        frameSize,
        imageSize,
        type,
        extra: ckeData,
        title: type === 'CIRCULAR' ? this.$translate.translateInstant('update_avatar_image') : '',
        isFromService: true,
      },
    };
    return this.aeroDialogService.show(ImageCropperComponent, showCaptionOptions);
  }
}
